import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 47 54",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M40.682 45.7133H35.4664V17.3282C35.4664 10.6481 30.0298 5.21139 23.3497 5.21139C16.6696 5.21139 11.237 10.6481 11.237 17.3282V26.8714H6.02148V17.3282C6.02148 7.77327 13.7948 0 23.3497 0C32.9046 0 40.6778 7.77327 40.6778 17.3282V45.7133H40.682Z",
			fill: "#0030CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.2822 53.9978H2.42419C1.08484 53.9978 0 52.9129 0 51.5736V26.4554C0 25.1161 1.08484 24.0312 2.42419 24.0312H44.2864C45.6257 24.0312 46.7106 25.1161 46.7106 26.4554V51.5736C46.7064 52.9129 45.6216 53.9978 44.2822 53.9978Z",
			fill: "#66A9FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.26 35.1046C27.26 32.9475 25.5118 31.1992 23.3546 31.1992C21.1975 31.1992 19.4492 32.9475 19.4492 35.1046C19.4492 36.8904 20.6551 38.3758 22.2865 38.8431V44.6804H24.4186V38.8431C26.0542 38.3758 27.26 36.8904 27.26 35.1046Z",
			fill: "#0030CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.49467 51.1546C2.38618 51.1546 2.30273 46.156 2.30273 39.9933C2.30273 33.8264 2.39036 28.832 2.49467 28.832C2.60315 28.832 2.6866 33.8306 2.6866 39.9933C2.6866 46.156 2.59898 51.1546 2.49467 51.1546Z",
			fill: "#F9F8FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.2946 40.1003C20.2821 40.1212 20.1111 40.0377 19.8357 39.8416C19.5603 39.6455 19.1931 39.3076 18.8301 38.8152C18.0999 37.8597 17.4365 36.124 17.8705 34.2506C18.3253 32.3813 19.698 31.1296 20.7745 30.6038C21.3211 30.3285 21.8009 30.1908 22.1347 30.1365C22.4685 30.0823 22.6563 30.0865 22.6604 30.1115C22.6771 30.1866 21.9219 30.2575 20.908 30.8458C19.9108 31.4091 18.6674 32.615 18.246 34.3424C17.8454 36.0697 18.417 37.7095 19.0554 38.6608C19.698 39.6372 20.3447 40.0419 20.2946 40.1003Z",
			fill: "#F9F8FF"
		})
	]
});
export default SvgLock;
